import React from "react";
import Navbar from "../pages/Navbar";
import "../styles/services.css";

const Services = () => {
    return (
        <div className="page-wrapper">
            <Navbar />
            <main>
                <div>
                    <section id="services">
                        <div className="krishtech1">
                            <h1>Our Services</h1>
                            <p>
                                At KrishTech Software, we provide comprehensive software
                                solutions tailored to meet your business needs. From web
                                applications to mobile apps, we deliver quality and innovation.
                            </p>
                        </div>

                        <div className="services-grid">
                            <div className="service-card">
                                <h3>💻 Web Applications</h3>
                                <p>
                                    We develop responsive, scalable web applications using modern
                                    technologies. Our web solutions are built for performance,
                                    security, and user experience.
                                </p>
                                <ul>
                                    <li>Responsive Design</li>
                                    <li>Cloud Integration</li>
                                    <li>Real-time Analytics</li>
                                    <li>API Development</li>
                                </ul>
                            </div>

                            <div className="service-card">
                                <h3>📱 Mobile Applications</h3>
                                <p>
                                    Create engaging mobile experiences with our iOS and Android
                                    development expertise. We build native and cross-platform
                                    applications that users love.
                                </p>
                                <ul>
                                    <li>Android Development</li>
                                    <li>iOS Development</li>
                                    <li>Cross-Platform Apps</li>
                                    <li>App Store Optimization</li>
                                </ul>
                            </div>

                            <div className="service-card">
                                <h3>🛠️ Software Products</h3>
                                <p>
                                    We design and develop custom software products for various
                                    industries. Our team combines technical expertise with
                                    business acumen to create solutions that drive growth and
                                    efficiency.
                                </p>
                                <ul>
                                    <li>Enterprise Solutions</li>
                                    <li>Business Automation</li>
                                    <li>Data Management</li>
                                    <li>Integration Services</li>
                                </ul>
                            </div>
                        </div>
                    </section>
                </div>
            </main>

            <footer className="footer">
                <div className="text_style">
                    <p>
                        &copy; 2026 KrishTech Software - Your IT Friend. All rights reserved.
                    </p>
                </div>
            </footer>
        </div>

    );
};

export default Services;
